import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    goodsList(data) {
        return axios.request({
            url: "point/category",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                res.data.forEach((item) => {
                    if (item.goods) {
                        item.goods.forEach((citem) => {
                            if (citem.imgurl) citem.imgurl = JSON.parse(citem.imgurl);
                            if (citem.tags) citem.tags = JSON.parse(citem.tags);

                        })
                    }
                })
            }
            return res

        });
    },
    btntpis: function (detail) {
        var tips = "";
        //sell price
        detail.buypoints = detail.sellingpoints;
        //片段是否需要邀请用户
        if (detail.myorders * 1 >= detail.inventory[0].limit) {
            detail.disabled = false;
            tips = "已达到购买上限"
        } else if (detail.invitednumber * 1 != 0 && (detail.invites * 1 < detail.invitednumber * 1)) {
            tips = "还差" + (detail.invitednumber * 1 - detail.invites * 1) + "人,立即邀请";
            detail.disabled = false;
            detail.needinvite = true;
        } else {
            //砍价
            detail.disabled = false;
            if (detail.max_discount * 1 > 0) {
                if (!detail.totalbargins) {
                    tips = "原价兑换";
                } else {
                    var buyp = detail.sellingpoints * 1 - detail.totalbargins * 1;
                    tips = `${buyp}币兑换`;
                    if (buyp <= 0) {
                        tips = "免费兑换";
                        buyp = 0;
                    }
                    detail.buypoints = buyp * 1;
                }
            } else {
                tips = "立即兑换";
            }
        }
        return tips;
    },
    goodsDetail(data) {
        return axios.request({
            url: "point/goodsdetail",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 == 200) {
                if (res.data.imgurl) res.data.imgurl = JSON.parse(res.data.imgurl);
                if (res.data.tags) res.data.tags = JSON.parse(res.data.tags);

                var detail  =   res.data;
                detail.disabled = true;

                var tips = '';
                if (!detail.gidhelps) {
                    detail.gidhelps = [];
                }
                //1 全部 3 是新用户
                switch (detail.state * 1) {
                    case 0:
                        tips = "兑换开始时间:" + detail.inventory[0].starttime;
                        break;
                    case 1:
                        switch (detail.level * 1) {
                            case 1:
                                tips = this.btntpis(detail);
                                break;
                            case 3:
                                if (detail.userrole.isnew != 1) {
                                    detail.disabled = true;
                                    detail.needinvite = false;
                                    tips = "仅限新用户兑换";
                                } else {
                                    tips = this.btntpis(detail);
                                    break;
                                }
                                break;
                        }
                        break;
                    case 2:
                        tips = "兑换结束";
                        break;
                    case 3:
                    case 4:
                        tips = "兑换结束";
                        break;
                }
                detail.tips = tips
                res.data = detail;
            }
            return res;
        });
    },
    likeGoods(data) {
        return axios.request({
            url: "user/likegoods",
            method: "post",
            data
        })
    }

}
